export default __webpack_public_path__ + "static/img-4-1805c1e24b06f431a03352262263bd30.png";